class ArticleCard extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector(".article-video-modal");
    this.articleCard = this.querySelector(".article-card");
    this.modalCloseButton = this.querySelector(".notification-box__icons");

    this.header = document.querySelector("sticky-header");
    this.mobileButton = document.querySelector(".mobile-menu-toggle");
    this.announcementBar = document.querySelector(".announcement-bar-section");
  }

  connectedCallback() {
    if (!this.modal || !this.modalCloseButton) return;

    this.articleCard.addEventListener("click", this.showModal.bind(this));
    this.articleCard.addEventListener("keydown", event => this.showModal(event));
    this.modalCloseButton.addEventListener("click", this.closeModal.bind(this));
    this.modal.addEventListener("keydown", event => this.closeModal(event));
  }

  showModal(event) {
    if (event.type === "keydown" && event.code !== "Enter" && event.code !== "Space") return;

    event.preventDefault();

    this.modal.classList.add("active");

    document.querySelector("body").style.overflow = "hidden";

    this.modal.focus();

    this.hideNavigation();
    this.reduceMobileMenuButtonIndex();
  }

  closeModal(event) {
    if (event.type === "keydown" && event.code !== "Escape") return;

    this.modal.classList.remove("active");

    document.querySelector("body").style.overflow = "auto";

    this.showNavigation();
    this.increaseMobileMenuButtonIndex();

    pauseAllMedia();
  }

  hideNavigation() {
    if (this.header) {
      this.header.classList.add("hidden");
    }
    if (this.announcementBar) {
      this.announcementBar.classList.add("hidden");
    }
  }

  showNavigation() {
    if (this.header) {
      this.header.classList.remove("hidden");
    }
    if (this.announcementBar) {
      this.announcementBar.classList.remove("hidden");
    }
  }

  increaseMobileMenuButtonIndex() {
    if (this.mobileButton) {
      this.mobileButton.style.zIndex = "999999999";
    }
  }

  reduceMobileMenuButtonIndex() {
    if (this.mobileButton) {
      this.mobileButton.style.zIndex = "1";
    }
  }
}

customElements.define("article-card", ArticleCard);
